import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { truncateWithEllipsis } from '../../utils/common';
import { Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap';
import * as XLSX from 'xlsx';

class FileDocumentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      previewContent: null,
      previewType: null,
      embedHeight: '500px',
    };
  }
  IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'gif'];
  DOCUMENT_TYPES = ['doc', 'docx', 'rtf', 'odt', 'ods', 'pptx'];
  SPREADSHEET_TYPES = ['xlsx', 'csv'];

  handleFileDownload = async () => {
    const { file, fileUniquePrefix } = this.props;
    try {
      const response = await axios.get(file.presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileUniquePrefix}-${file.fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  updateHeight = () => {
    const screenHeight = window.innerHeight;
    const calculatedHeight = screenHeight * 0.7;
    this.setState({ embedHeight: `${calculatedHeight}px` });
  };
  handlePreviewFile = async () => {
    const { file } = this.props;
    const fileType = file?.fileName?.split('.').pop().toLowerCase();
    const fileUrl = file.presignedUrl;

    try {
      let previewContent = null;
      if (!this.IMAGE_TYPES.includes(fileType)) {
        const response = await axios.get(fileUrl, { responseType: 'blob' });

        previewContent = await this.getFileContent(response, fileType, fileUrl);
      } else {
        previewContent = (
          <img src={fileUrl} alt="preview" className="img-fluid" />
        );
      }
      this.setState({ showModal: true, previewContent, previewType: fileType });
    } catch (error) {
      console.error('Error previewing the file', error);
    }
  };

  getFileContent = async (response, fileType, fileUrl) => {
    switch (true) {
      case fileType === 'pdf':
        return (
          <embed
            src={fileUrl}
            width="100%"
            height={`${this.state.embedHeight}px`}
            type="application/pdf"
          />
        );

      case fileType === 'txt':
        const textData = await response.data.text();
        return <pre>{textData}</pre>;

      case this.IMAGE_TYPES.includes(fileType):
        return <img src={fileUrl} alt="preview" className="img-fluid" />;

      case this.SPREADSHEET_TYPES.includes(fileType):
        return this.getExcelPreview(response.data);

      case this.DOCUMENT_TYPES.includes(fileType):
        return (
          <iframe
            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
            width="100%"
            height="600px"
            frameBorder="0"
          />
        );

      default:
        return <p>Preview not available for this file type.</p>;
    }
  };

  getExcelPreview = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0]; // Selecting the first sheet
        const worksheet = XLSX.utils.sheet_to_html(workbook.Sheets[sheetName]);
        resolve(<div dangerouslySetInnerHTML={{ __html: worksheet }} />);
      };
      reader.readAsArrayBuffer(blob);
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      previewContent: null,
      previewType: null,
    });
  };

  getFileTypeIcon = (fileType) => {
    switch (fileType) {
      case 'pdf':
        return <i className="fa fa-file-pdf-o" aria-hidden="true"></i>;
      case 'doc':
      case 'docx':
        return <i className="fa fa-file-word-o" aria-hidden="true"></i>;
      case 'xls':
      case 'xlsx':
      case 'csv':
        return <i className="fa fa-file-excel-o" aria-hidden="true"></i>;
      case 'ppt':
      case 'pptx':
        return <i className="fa fa-file-powerpoint-o" aria-hidden="true"></i>;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <i className="fa fa-file-image-o" aria-hidden="true"></i>;
      case 'txt':
        return <i className="fa fa-file-text-o" aria-hidden="true"></i>;
      default:
        return <i className="fa fa-file" aria-hidden="true"></i>;
    }
  };

  render() {
    const {
      DocumentIcon,
      DocumentName,
      DocumentSize,
      DocumentDate,
      ImageUrl,
      handleDeleteFile,
      file,
    } = this.props;

    const { showModal, previewContent } = this.state;

    return (
      <div
        className={this.props.fullWidth ? '' : 'col-lg-3 col-md-4 col-sm-12'}
      >
        <div className="documentCard">
          <div className="file">
            <Link to="#">
              <div className="icon">
                {DocumentIcon
                  ? DocumentIcon
                  : // <i className="fa fa-file" aria-hidden="true"></i>
                    this.getFileTypeIcon(
                      file?.fileName?.split('.').pop().toLowerCase(),
                    )}
              </div>

              <OverlayTrigger
                trigger={['hover', 'focus']}
                key="right"
                placement="right"
                overlay={
                  <Popover id={`popover-positioned-right`}>
                    <Popover.Title as="h3">{`File Info`}</Popover.Title>
                    <Popover.Content>
                      <strong>Name</strong>{' '}
                      {truncateWithEllipsis(DocumentName, 50)} <br />
                      <strong>Uploaded by user Id</strong> {file.createdBy}{' '}
                      <br />
                    </Popover.Content>
                  </Popover>
                }
                flip={true} // Enable flipping to keep the popover within the viewport
                boundary="viewport" // Restrict the popover within the viewport
              >
                <div className="file-name">
                  <p className="m-b-5 text-muted">
                    {/* {truncateWithEllipsis(DocumentName, 13)} */}
                    {DocumentName}
                  </p>
                  <small>
                    Size: {DocumentSize}{' '}
                    <span className="date text-muted">{DocumentDate}</span>
                  </small>
                </div>
              </OverlayTrigger>

              <div className="button-wrapper">
                <button
                  onClick={this.handleFileDownload}
                  type="button"
                  className="btn btn-icon"
                >
                  <i className="fa fa-download"></i>
                </button>
                <button
                  onClick={this.handlePreviewFile}
                  type="button"
                  className="btn btn-icon"
                >
                  <i className="fa fa-eye"></i>
                </button>
                <button
                  onClick={handleDeleteFile}
                  type="button"
                  className="btn btn-icon"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </Link>
          </div>
        </div>

        <Modal show={showModal} onHide={this.handleCloseModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>File Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>{previewContent}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

FileDocumentCard.propTypes = {
  DocumentName: PropTypes.string.isRequired,
  DocumentSize: PropTypes.string.isRequired,
  DocumentDate: PropTypes.string.isRequired,
  handleDeleteFile: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  fileUniquePrefix: PropTypes.string.isRequired,
};

const mapStateToProps = ({ mailInboxReducer, analyticalReducer }) => ({});

export default connect(mapStateToProps, {})(FileDocumentCard);
